
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import EditTerminalReceiverModal from '@/views/supplyChain/platform/components/EditTerminalReceiverModal.vue';

@Component({
  components: {
    EditTerminalReceiverModal,
  },
})
export default class SelectAddressModal extends Vue {
  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @Ref('editTerminalReceiverModal')
  editTerminalReceiverModal!: EditTerminalReceiverModal;

  visible = false;
  loading = false;

  distributorId: any = '';

  dataSource: any[] = [];

  selectedRowKeys: any[] = [];
  selectedRecords: any[] = [];

  columns = [
    {
      title: '收货人',
      dataIndex: 'receiver',
      align: 'center',
      width: 110,
    },
    {
      title: '联系电话',
      dataIndex: 'phone',
      align: 'center',
      width: 130,
    },
    {
      title: '收货地址',
      dataIndex: 'fullAddress',
      align: 'center',
      scopedSlots: { customRender: 'fullAddress' },
    },
    {
      title: '是否默认',
      dataIndex: 'is_default',
      align: 'center',
      width: 90,
      scopedSlots: { customRender: 'isDefault' },
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      width: 90,
      scopedSlots: { customRender: 'status' },
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  get rowSelection() {
    return {
      type: 'radio',
      selectedRowKeys: this.selectedRowKeys,
      onChange: this.onSelectChange,
      getCheckboxProps: (record: any) => ({
        props: {
          disabled: record.status !== 1,
        },
      }),
    };
  }

  customRow(record: any) {
    return {
      on: {
        click: () => {
          if (record.status !== 1) return;
          this.selectedRowKeys = [record.id];
          this.selectedRecords = [record];
        },
      },
    };
  }

  onSelectChange(selectedRowKeys: any[], selectedRows: any[]) {
    this.selectedRowKeys = selectedRowKeys;
    this.selectedRecords = selectedRows;
  }

  formatFullAddress(record: any) {
    const region = [record.province, record.city, record.district]
      .filter(Boolean)
      .join('');
    return `${region}${record.address || ''}`;
  }

  open(distributorId: any) {
    this.distributorId = distributorId;
    this.visible = true;
    this.selectedRowKeys = [];
    this.selectedRecords = [];
    this.pagination.current = 1;
    this.getList();
  }

  async getList() {
    if (!this.distributorId) return;
    this.loading = true;
    try {
      const res = await this.supplyService.getDeliveryList({
        distributor_id: this.distributorId,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
      });
      if (res && res.list) {
        this.dataSource = res.list;
        this.pagination.total = res.total || 0;
        this.autoSelectDefault();
      } else {
        this.dataSource = [];
        this.pagination.total = 0;
      }
    } finally {
      this.loading = false;
    }
  }

  // 当前未选中任何行时，自动选中 is_default === 1 且状态启用的默认地址
  autoSelectDefault() {
    if (this.selectedRowKeys.length) return;
    const defaultRow = this.dataSource.find(
      (item: any) => Number(item.is_default) === 1 && Number(item.status) === 1,
    );
    if (defaultRow) {
      this.selectedRowKeys = [defaultRow.id];
      this.selectedRecords = [defaultRow];
    }
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getList();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getList();
  }

  openCreate() {
    if (!this.distributorId) {
      this.$message.warning('缺少经销商信息');
      return;
    }
    this.editTerminalReceiverModal.open();
  }

  onAddressCreated() {
    this.pagination.current = 1;
    this.selectedRowKeys = [];
    this.selectedRecords = [];
    this.getList();
  }

  handleOk() {
    if (!this.selectedRecords.length) {
      this.$message.warning('请选择一个收货地址');
      return;
    }
    this.$emit('select', this.selectedRecords[0]);
    this.handleCancel();
  }

  handleCancel() {
    this.visible = false;
    this.selectedRowKeys = [];
    this.selectedRecords = [];
  }
}
